import { initUpdatePasswordForm } from '@/js/account/initPasswordUpdateForm.ts';
import { initProfileUpdateForm } from '@/js/account/initProfileUpdateForm.ts';
import { initSubscribeForm } from '@/js/account/initSubscribeForm.ts';
import { initCartItems } from '@/js/cart-item.ts';
import { initCart, initCartTotal } from '@/js/cart.ts';
import { initCategoryFilters } from '@/js/category-filters.ts';
import { initCheckout } from '@/js/checkout.ts';
import { initCompare } from '@/js/compare.ts';
import { initEcommerceDetail, initEcommercePurchase } from '@/js/ecommerce.ts';
import { initFavorite } from '@/js/favorite.ts';
import { initForms } from '@/js/forms.ts';
import { initReachGoals } from '@/js/goal.ts';
import { initHeaderSearch } from '@/js/header-search.ts';
import { initLoginForm } from '@/js/initLoginForm.ts';
import { initPasswordResetForm } from '@/js/initPasswordResetForm.ts';
import { initPasswordResetHandleForm } from '@/js/initPasswordResetHandleForm.ts';
import { initRegisterForm } from '@/js/initRegisterForm.ts';
import { initSearchStore } from '@/js/initSearchStore.ts';
import { initTestVisit } from '@/js/metrika.ts';
import { initMobileMenu } from '@/js/mobile-menu.ts';
import { initProductAvailableModals } from '@/js/modal/product-available-modal.ts';
import { initPopovers } from '@/js/popover.ts';
import { initProductCartForms } from '@/js/product-cart-form.ts';
import { initProductsSearch } from '@/js/products-search.ts';
import { initQuantitySelectors } from '@/js/quantity-selector.ts';
import { initSortSelectField } from '@/js/sort.ts';
import { initTagsPanel } from '@/js/tags-panel.ts';
import { initCarousel, initCompareCarousels, initProductCarousel } from './carousel.ts';
import { initScrollToTab } from './scroll-to-tab.ts';
import { switchDisplayView } from './switch-display-view.ts';
import '@zachleat/details-utils';
import './map.js';
import './vk-fancybox.ts';
import './fancybox.ts';
import './tippy.ts';
import './show-more.ts';
import './installation-banner-form.ts';
import './phone-maska.ts';
import './tab.ts';
import './calculate-total.ts';
import './cookie-agreements/cookie-agreements.js';

// Метка тестовых визитов должна встать до отправки целей и e-commerce.
initTestVisit();
initReachGoals();
initEcommerceDetail();
initEcommercePurchase();

const carouselElements = document.querySelectorAll<HTMLElement>('.js-carousel');
for (const carouselElement of carouselElements) {
  initCarousel(carouselElement);
}

initProductCarousel();
initMobileMenu();
initHeaderSearch();
switchDisplayView('.js-products-view-buttons');
void initCartTotal();
void initCart();
initScrollToTab();
initFavorite();
initCompare();
initCompareCarousels();
void initCheckout();
void initCartItems();
initSearchStore();
void initCategoryFilters();
initProductsSearch();
initRegisterForm();
initLoginForm();
void initProductCartForms();
initForms();
initSortSelectField();
initQuantitySelectors();
initPasswordResetForm();
initPasswordResetHandleForm();
initProductAvailableModals();

initSubscribeForm();
initProfileUpdateForm();
initRegisterForm();
initUpdatePasswordForm();
initPopovers();
initTagsPanel();
